import React, { useState } from "react";
import { BrowserRouter, Route, Switch, Link, Redirect } from "react-router-dom";
// import team from "./views/team";
import clsx from "clsx";
import { SocketIOProvider, useSocket } from "use-socketio";
// import tabnav from "./views/tabnav";
import TaskCreate from "./views/actions/createAction";
import TemplaleEdit from "./views/templateTools/templateeditor";
// import template from "./views/template";
import TemplateNav from "./views/templateTools/templatenav";
import workflow from "./views/workflow/hierarchy";
import workflowImg from "./Assets/workflow.png";
import Team from "./views/newTeam/teamNav.js";
import Company from "./views/Company/company";
import Action from "./views/actions/action";
import Analytics from "./views/analytics/analytics";
import Performance from "./views/analytics/Performance/PerformanceIndex";
import Drawer from "@material-ui/core/Drawer";
import Billing from "./views/Billing/BillingNav";
// import Trends from "./views/analytics/Trends";
import ActivityLog from "./views/activityLog";
import ActionAnalytics from "./views/analytics/Actions/Action";
import ForgotPassword from "./views/forgotPassword/ForgotPassword";
import ChangePassword from "./views/changePassword/changePassword";
import Inspection from "./views/Inspection/inspectionnav";
import scheduleCreate from "./views/schedule/schedulecreate";
import schedule from "./views/schedule/schedulenav";
import Onbording from "./views/Onbording/onbording";
// import Users from "./views/team/users";
import Main from "./views/main";
import EditTemplate from "./views/NewTemplate";
import EmailTemplate from "./views/emailTemplate/emailTemplate";
import Reportview from "./views/Inspection/viewreport";
import Signin from "./views/SignIn/signin";
import Signup from "./views/signUp/signup.js";
import Sites from "./views/sites/sites";
// import Addnewuser from "./views/team/addnewuser";
// import Addnewusergroup from "./views/team/addnewgroup";
// import Purchase from "./views/purchase";
// import Account from "./views/account/account";
import Account from "./views/NewAccount/account";
import InspectionEdit from "./views/Inspection/inspection-edit";
import TemplateReportStyle from "./views/templateReportStyle/templateReportStyle";
import TemplateReportList from "./views/templateReportList/templateReportList";
import InspectionPrint from "./views/Inspection/inspection-print";
import NotPermitted from "./views/notPermitted/notPermitted";
// import ExecutiveDashboard from "./views/analytics/executiveDashboard/index";
import ExecutiveNav from "./views/executiveDashboard/executiveDashNav";
import Notification from "./views/Notification";
import Pricing from "./views/Pricing";
import Blocked from "./views/Blocked";
import AddPackagePlan from "./views/Pricing/AddPackagePlan";
import PackageBuy from "./views/Pricing/PackageBuy";
import LicenseAdd from "./views/lisenceAdd/lisenceAdd";
import LicenseRenew from "./views/licenseRenew/lisenceRenew";
import PlanUrAudits from "./views/planYourAudit/planYourAudits";
import PublicTemplates from "./views/publicTemplates/publicTemplates";
import PlanUrAuditsExisting from "./views/planYourAuditsExisting/planYourAuditsExisting";
import TemplateNew from "./views/TemplateNew2/templateNav";
import GlobalResponse from "./views/templateTools/templateResponse";
import GlobalApi from "./Global";
import "./App.css";
import CssBaseline from "@material-ui/core/CssBaseline";
import refresh_token from "./Global/refresh_token";
import { PersistGate } from "redux-persist/integration/react";
import teamG from "./Assets/TeamG.png";
import siteG from "./Assets/siteG.png";
// import reportG from "./Assets/report.png";
import companyG from "./Assets/Company_icon.png";
import reportG from "./Assets/report.png";
import SideNav from "./SideNav";
import Spinner from "./Global/Spinner";
import { useRef, useEffect } from "react";
import { useHistory } from "react-router-dom";
import { Provider } from "react-redux";
import { store, persistor } from "./Redux/Store/store";
import { useSelector, useDispatch } from "react-redux";
import { closeSideBar } from "./Redux/Actions/sidebarAction";
import comapnyArrReducer from "./Redux/Reducers/companyArrReducer";

export default function App() {
  let sidebarOpen = useSelector((state) => state.sidebarReducer.isCollapsed);
  let language = useSelector((state) => state.languageReducer.language);
  console.log("DRAWER STSTUS >>>>>>>>>>>>", sidebarOpen);

  const dispatch = useDispatch();
  const history = useHistory();

  return (
    <div style={{ width: "100%", height: "100vh", overflow: "hidden" }}>
      <CssBaseline />
      <BrowserRouter>
        <Drawer
          className="sidebarDrawer"
          anchor={language == "ar" ? "left" : "right"}
          variant="persistent"
          open={sidebarOpen}
          onClose={(e) => {
            e.preventDefault();
            dispatch(closeSideBar());
          }}
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "flex-end",
              width: "100%",
              height: "100%",
            }}
          >
            <div
              className="innerDrawer"
              style={{
                boxShadow:
                  "0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)",
                backgroundColor: "white",
                textAlign: "center",
                paddingTop: 20,
                paddingBottom: 20,
                width: 70,
                height: "auto",
                borderRadius:
                  language == "ar" ? "0px 50px 50px 0px" : "50px 0px 0px 50px",
                position: "relative",
              }}
            >
              <div
                className="closeIcon"
                style={{
                  right: language !== "ar" && "45px",
                  left: language == "ar" && "45px",
                }}
                onClick={(e) => {
                  e.preventDefault();
                  dispatch(closeSideBar());
                }}
              >
                <p
                  style={{
                    margin: 0,
                    fontweight: "bold",
                    color: "white",
                    fontSize: "10px",
                  }}
                >
                  X
                </p>
              </div>
              <Link to="/company">
                <div
                  style={{
                    color: "white",
                    paddingTop: 8,
                    paddingBottom: 8,
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    textAlign: "center",
                    flexDirection: "column",
                    fontSize: "10px",
                    cursor: "pointer",
                  }}
                  // onClick={() => {
                  //   history.push("/company");
                  // }}
                >
                  <div style={{ alignItems: "center" }}>
                    <img src={companyG} className="sidebar-img" />
                  </div>
                  <p className="navLableNew">{"Company"}</p>
                </div>
              </Link>

              <Link to="/team">
                <div
                  style={{
                    color: "white",
                    paddingTop: 8,
                    paddingBottom: 8,
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    textAlign: "center",
                    flexDirection: "column",
                    fontSize: "10px",
                    cursor: "pointer",
                  }}
                  // onClick={() => {
                  //   // history.push("/team");
                  // }}
                >
                  <div style={{ alignItems: "center" }}>
                    <img src={teamG} className="sidebar-img" />
                  </div>
                  <p className="navLableNew">{"Team"}</p>
                </div>
              </Link>

              <Link to="/sites">
                <div
                  style={{
                    color: "white",
                    paddingTop: 8,
                    paddingBottom: 8,
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    textAlign: "center",
                    flexDirection: "column",
                    fontSize: "10px",
                    cursor: "pointer",
                  }}
                  // onClick={() => {
                  //   //history.push("/sites");
                  // }}
                >
                  <div style={{ alignItems: "center" }}>
                    <img src={siteG} className="sidebar-img" />
                  </div>

                  <p className="navLableNew">{"Sites"}</p>
                </div>
              </Link>

              {/* <Link to="/workflow">
                <div
                  style={{
                    color: "white",
                    paddingTop: 8,
                    paddingBottom: 8,
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    textAlign: "center",
                    flexDirection: "column",
                    fontSize: "10px",
                    cursor: "pointer",
                  }}
                  // onClick={() => {
                  //   //history.push("/sites");
                  // }}
                >
                  <div style={{ alignItems: "center" }}>
                    <img src={workflowImg} className="sidebar-img" />
                  </div>

                  <p className="navLableNew">{"Workflow"}</p>
                </div>
              </Link> */}

              {/* <Link to="/template-report-list">
                <div
                  style={{
                    color: "white",
                    paddingTop: 8,
                    paddingBottom: 8,
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    textAlign: "center",
                    flexDirection: "column",
                    fontSize: "10px",
                    cursor: "pointer",
                  }}
                  // onClick={() => {
                  //   // history.push("/team");
                  // }}
                >
                  <div style={{ alignItems: "center" }}>
                    <img src={reportG} className="sidebar-img" />
                  </div>
                  <p className="navLableNew">{"Report"}</p>
                </div>
              </Link> */}
            </div>
          </div>
        </Drawer>

        <SwitchCont />
      </BrowserRouter>
    </div>
  );
}

const PrivateRoute = ({
  component: Component,
  permission,
  role,
  sidebar,
  sidebarToggle,
  toggleDrawer,
  ...rest
}) => {
  // console.log("Permission", permission)
  let user = useSelector((state) => state.userReducer.user);
  return (
    <Route
      {...rest}
      render={(props) =>
        permission === true && role === true ? (
          <SideNav
            sidebar={sidebar}
            toggleDrawer={toggleDrawer}
            sidebarToggle={sidebarToggle}
            children={<Component {...props} />}
          />
        ) : (
          <SideNav
            sidebar={sidebar}
            toggleDrawer={toggleDrawer}
            children={<Redirect to="/not-permitted" />}
          />
        )
      }
    />
  );
};
const SideBarRoute = ({ component: Component, permission, ...rest }) => {
  // console.log("Permission", permission)
  return (
    <Route
      {...rest}
      render={(props) => <SideNav children={<Component {...props} />} />}
    />
  );
};

function SwitchCont() {
  const [permissions_obj, setPermissionObj] = useState({});
  const [packageCurrentDetails, setPackageCurrentDetails] = React.useState({});
  const [loader, setLoader] = useState(true);
  const [packageDetails, setPackageDetails] = React.useState(null);
  let company = useSelector((state) => state.companyReducer.company);
  let user = useSelector((state) => state.userReducer.user);
  const history = useHistory();

  console.log("COMPPANY", company);

  function getCurrentPackage() {
    let localstorage = localStorage.getItem("UserData");
    var data = JSON.parse(localstorage);
    let token = data?.token;
    let params = {
      organization_id: data?.organization_id,
    };
    // console.log(data.user_id);
    let query = Object.keys(params)
      .map((k) => encodeURIComponent(k) + "=" + encodeURIComponent(params[k]))
      .join("&");

    fetch(GlobalApi + "/Package/get_package_inspection_limit?" + query, {
      method: "GET",
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
      },
    })
      .then((responseJson) => responseJson.json())
      .then(async (response) => {
        console.log(
          "response of get packageCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCC",
          response
        );
        if (response.status === "Request is Valid") {
          console.log(response);
          setPackageCurrentDetails(response.data);
        } else {
          setPackageCurrentDetails("expired");
        }
      })
      .catch((error) => console.log(error.message));
  }

  const getPackageDetails = async () => {
    let localstorage = localStorage.getItem("UserData");
    var data = JSON.parse(localstorage);
    let token = data?.token;
    if (data == undefined) {
      return <Redirect to={"/signin"} />;
    }
    let package_inquiry = {
      user_id: data.user_id,
      organization_id: data.organization_id,
    };

    let query = Object.keys(package_inquiry)
      .map(
        (k) =>
          encodeURIComponent(k) + "=" + encodeURIComponent(package_inquiry[k])
      )
      .join("&");
    let req = await fetch(
      GlobalApi + "/Package/get_user_license_details?" + query,
      {
        method: "GET",
        headers: {
          Authorization: "Bearer " + token,
          "Content-Type": "application/json",
        },
      }
    );

    let reqJson = await req.json();

    if (
      reqJson?.package?.license?.status === "expired" ||
      reqJson?.package?.license?.status === "deactive"
    ) {
      history.replace("/billing");
    } else {
      setPackageDetails(reqJson.package);
    }
  };

  console.log(
    "permissions_objTTTTTTTTTTTTTTTTTTTTTTTTTTTTTTTTTTTTTTTTTTT",
    permissions_obj
  );
  console.log("COMPANY IN SWITCH BCONT", company);
  console.log("USER IN SWITCH BCONT", user);

  useEffect(
    () => {
      getPermissions();
    },
    [company?.id]
  );

  useEffect(() => {
    getPackageDetails();
  }, []);

  useEffect(() => {
    const imageUrlList = [
      "https://server.uraudits.com/view?Key=0738689e-5df5-4572-8350-904e5ea385cc/b3df7e59-8bbe-4598-aeca-5ef7d06d135cundefined/profile/1647328601853.png",
      "https://server.uraudits.com/view?Key=admin/report_templates/1637394195954.png",
      "https://server.uraudits.com/view?Key=admin/report_templates/1637394527765.png",
      "https://server.uraudits.com/view?Key=admin/report_templates/1637394424454.png",
      "https://server.uraudits.com/view?Key=admin/report_templates/1637394383322.png",
      "https://server.uraudits.com/view?Key=admin/report_templates/1637394274570.png",
    ];
    preloadImages(imageUrlList);
  }, []);

  function preloadImages(urlList) {
    let fragment = document.createDocumentFragment();
    for (let i = 0; i < urlList.length; i++) {
      const imgUrl = urlList[i];
      const linkEl = document.createElement("link");
      linkEl.setAttribute("rel", "preload");
      linkEl.setAttribute("href", imgUrl);
      linkEl.setAttribute("as", "image");
      fragment.appendChild(linkEl);
    }
    document.head.appendChild(fragment);
  }

  const getPermissions = () => {
    console.log("$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$");
    let localstorage = localStorage.getItem("UserData");
    var data = JSON.parse(localstorage);
    let token = data?.token;
    if (data !== null) {
      let params = { company_id: company?.id, user_id: data?.user_id };
      let query = Object.keys(params)
        .map((k) => encodeURIComponent(k) + "=" + encodeURIComponent(params[k]))
        .join("&");

      fetch(GlobalApi + "/User/get_user_permission_of_company?" + query, {
        method: "GET",
        headers: {
          Authorization: "Bearer " + token,
          "Content-Type": "application/json",
        },
      })
        .then((responseJson) => responseJson.json())
        .then(async (response) => {
          console.log(response);
          if (response.msg === "success") {
            let permissionsObj = {};
            await response.data.map((v) => {
              permissionsObj[(v?.title)] = true;
            });
            console.log("Permissions Obj >>>>>>>", permissionsObj);

            setPermissionObj(permissionsObj);
            setLoader(false);
          } else if (
            response.error === "jwt expired" ||
            response.error === "invalid token" ||
            response.error === "invalid signature" ||
            response.error === "jwt malformed" ||
            response.error === "Unexpected token"
          ) {
            let status = await refresh_token();
            // console.log(status);
            if (status) {
              // console.log("opopopop");
              getPermissions();
            }
          }
        })
        .catch((error) => {
          // localStorage.clear();
          // window.location.replace("/signin");
          console.log(error.message);
        });
    } else {
      setLoader(false);
    }
  };

  if (loader !== false) {
    return <Spinner />;
  }
  return (
    <Switch>
      <PrivateRoute
        sidebar={true}
        permission={
          user?.super_admin
            ? true
            : permissions_obj["Admin"]
            ? true
            : permissions_obj["Template Creation"]
            ? true
            : false
        }
        role={
          packageDetails?.package?.title !== "Enterprise" &&
          packageDetails?.package?.title !== "Free"
            ? true
            : company?.role === "admin"
            ? true
            : company?.role === "inspector"
            ? true
            : false
        }
        // permission={true}
        path="/show"
        component={(props) => <EditTemplate {...props} />}
      />
      <Route
        sidebar={false}
        permission={true}
        role={true}
        exact
        path={"/signin"}
        // component={Signin}
        component={(props) => <Signin func={(e) => getPermissions()} />}
      />

      <PrivateRoute
        sidebar={true}
        permission={true}
        role={true}
        exact
        path={"/not-permitted"}
        component={NotPermitted}
      />

      <Route
        exact
        path="/signup"
        component={(props) => <Signup func={(e) => getPermissions()} />}
      />

      <Route
        exact
        path="/forgotpassword"
        component={(props) => <ForgotPassword />}
      />

      <Route
        path="/changePassword/:user_id"
        component={(props) => <ChangePassword />}
      />

      <Route exact path="/blocked" component={(props) => <Blocked />} />

      <PrivateRoute
        sidebar={true}
        permission={true}
        role={
          packageDetails?.package?.title !== "Enterprise" &&
          packageDetails?.package?.title !== "Free"
            ? true
            : company?.role === "admin"
            ? true
            : company?.role === "inspector"
            ? true
            : false
        }
        exact
        path="/reportview"
        component={(props) => (
          <Reportview func={(e) => this.props.hideNav(e)} />
        )}
      />

      <PrivateRoute
        sidebar={true}
        permission={true}
        role={true}
        path="/dashboard"
        component={Main}
      />

      <PrivateRoute
        sidebar={true}
        permission={true}
        role={true}
        exact
        path="/"
        component={Main}
        // component={(props) => (
        //   <Main showside={(e) => this.props.showNav(e)} />
        // )}
      />
      {/* <PrivateRoute
        sidebar={true}
        // permission={true}
        permission={
          permissions_obj["Admin"]
            ? true
            : permissions_obj["Data Access"]
            ? true
            : false
        }
        path="/team/user/list"
        component={Team}
      /> */}

      <PrivateRoute
        sidebar={true}
        // permission={true}
        permission={
          user?.super_admin
            ? true
            : permissions_obj["Admin"]
            ? true
            : permissions_obj["Data Access"]
            ? true
            : false
        }
        role={
          packageDetails?.package?.title !== "Enterprise" &&
          packageDetails?.package?.title !== "Free"
            ? true
            : company?.role === "admin"
            ? true
            : false
        }
        path="/team"
        component={Team}
      />

      <PrivateRoute
        sidebar={true}
        // permission={true}
        permission={
          user?.super_admin
            ? true
            : permissions_obj["Admin"]
            ? true
            : permissions_obj["Activity Log"]
            ? true
            : false
        }
        role={
          packageDetails?.package?.title !== "Enterprise" &&
          packageDetails?.package?.title !== "Free"
            ? true
            : company?.role === "admin"
            ? true
            : company?.role === "management"
            ? true
            : false
        }
        path="/activity_log"
        component={ActivityLog}
      />

      <PrivateRoute
        sidebar={true}
        // permission={true}
        permission={
          user?.super_admin
            ? true
            : permissions_obj["Admin"]
            ? true
            : permissions_obj["Data Access"]
            ? true
            : false
        }
        role={
          packageDetails?.package?.title !== "Enterprise" &&
          packageDetails?.package?.title !== "Free"
            ? true
            : company?.role === "admin"
            ? true
            : company?.role === "inspector"
            ? true
            : false
        }
        path="/template-report-list"
        component={TemplateReportList}
      />

      <PrivateRoute
        sidebar={true}
        // permission={true}
        permission={
          user?.super_admin
            ? true
            : permissions_obj["Admin"]
            ? true
            : permissions_obj["Data Access"]
            ? true
            : false
        }
        role={
          packageDetails?.package?.title !== "Enterprise" &&
          packageDetails?.package?.title !== "Free"
            ? true
            : company?.role === "admin"
            ? true
            : company?.role === "inspector"
            ? true
            : false
        }
        path="/template-report-style/:temp_id/:template_name"
        component={TemplateReportStyle}
      />

      <PrivateRoute
        sidebar={true}
        // permission={true}
        permission={
          user?.super_admin
            ? true
            : permissions_obj["Admin"]
            ? true
            : permissions_obj["Data Access"]
            ? true
            : false
        }
        role={
          packageDetails?.package?.title !== "Enterprise" &&
          packageDetails?.package?.title !== "Free"
            ? true
            : company?.role === "admin"
            ? true
            : false
        }
        path="/onbording"
        component={Onbording}
      />

      <PrivateRoute
        sidebar={true}
        // permission={true}
        permission={
          user?.super_admin
            ? true
            : permissions_obj["Admin"]
            ? true
            : permissions_obj["Data Access"]
            ? true
            : false
        }
        role={
          packageDetails?.package?.title !== "Enterprise" &&
          packageDetails?.package?.title !== "Free"
            ? true
            : company?.role === "admin"
            ? true
            : false
        }
        path="/sites"
        component={Sites}
      />

      <PrivateRoute
        sidebar={true}
        // permission={true}
        permission={
          user?.super_admin
            ? true
            : permissions_obj["Admin"]
            ? true
            : permissions_obj["Template Creation"]
            ? true
            : false
        }
        role={
          packageDetails?.package?.title !== "Enterprise" &&
          packageDetails?.package?.title !== "Free"
            ? true
            : company?.role === "admin"
            ? true
            : company?.role === "inspector"
            ? true
            : false
        }
        path="/plan-your-audits"
        component={PlanUrAudits}
      />

      <PrivateRoute
        sidebar={true}
        // permission={true}
        permission={
          user?.super_admin
            ? true
            : permissions_obj["Admin"]
            ? true
            : permissions_obj["Data Access"]
            ? true
            : false
        }
        role={
          packageDetails?.package?.title !== "Enterprise" &&
          packageDetails?.package?.title !== "Free"
            ? true
            : company?.role === "admin"
            ? true
            : company?.role === "inspector"
            ? true
            : false
        }
        path="/email-template/:temp_id/:template_name"
        component={EmailTemplate}
      />

      <PrivateRoute
        sidebar={true}
        // permission={true}
        permission={
          user?.super_admin
            ? true
            : permissions_obj["Admin"]
            ? true
            : permissions_obj["Data Access"]
            ? true
            : false
        }
        role={
          packageDetails?.package?.title !== "Enterprise" &&
          packageDetails?.package?.title !== "Free"
            ? true
            : company?.role === "admin"
            ? true
            : company?.role === "inspector"
            ? true
            : false
        }
        path="/plan-your-audits-public-library"
        component={PublicTemplates}
      />

      <PrivateRoute
        sidebar={true}
        // permission={true}
        permission={
          user?.super_admin
            ? true
            : permissions_obj["Admin"]
            ? true
            : permissions_obj["Data Access"]
            ? true
            : false
        }
        role={
          packageDetails?.package?.title !== "Enterprise" &&
          packageDetails?.package?.title !== "Free"
            ? true
            : company?.role === "admin"
            ? true
            : false
        }
        path="/company"
        component={Company}
      />

      <PrivateRoute
        sidebar={true}
        // permission={true}
        permission={
          user?.super_admin
            ? true
            : permissions_obj["Admin"]
            ? true
            : permissions_obj["Data Access"]
            ? true
            : false
        }
        role={
          packageDetails?.package?.title !== "Enterprise" &&
          packageDetails?.package?.title !== "Free"
            ? true
            : company?.role === "admin"
            ? true
            : company?.role === "inspector"
            ? true
            : false
        }
        path="/template"
        component={TemplateNew}
      />

      <PrivateRoute
        sidebar={true}
        // permission={true}
        permission={
          user?.super_admin
            ? true
            : permissions_obj["Admin"]
            ? true
            : permissions_obj["Billing Management"]
            ? true
            : false
        }
        role={
          packageDetails?.package?.title !== "Enterprise" &&
          packageDetails?.package?.title !== "Free"
            ? true
            : company?.role === "admin"
            ? true
            : company?.role === "management"
            ? true
            : false
        }
        path="/billing"
        component={Billing}
      />

      <PrivateRoute
        sidebar={true}
        // permission={true}
        permission={
          user?.super_admin
            ? true
            : permissions_obj["Admin"]
            ? true
            : permissions_obj["Data Access"]
            ? true
            : false
        }
        role={
          packageDetails?.package?.title !== "Enterprise" &&
          packageDetails?.package?.title !== "Free"
            ? true
            : company?.role === "admin"
            ? true
            : company?.role === "inspector"
            ? true
            : false
        }
        path="/global_response"
        component={GlobalResponse}
      />
      <PrivateRoute
        sidebar={true}
        // permission={true}
        permission={
          user?.super_admin
            ? true
            : permissions_obj["Admin"]
            ? true
            : permissions_obj["Data Access"]
            ? true
            : false
        }
        role={
          packageDetails?.package?.title !== "Enterprise" &&
          packageDetails?.package?.title !== "Free"
            ? true
            : company?.role === "admin"
            ? true
            : company?.role === "inspector"
            ? true
            : false
        }
        path="/schedule"
        component={schedule}
      />
      <PrivateRoute
        sidebar={true}
        // permission={true}
        permission={
          user?.super_admin
            ? true
            : permissions_obj["Admin"]
            ? true
            : permissions_obj["Data Access"]
            ? true
            : false
        }
        role={
          packageDetails?.package?.title !== "Enterprise" &&
          packageDetails?.package?.title !== "Free"
            ? true
            : company?.role === "admin"
            ? true
            : company?.role === "inspector"
            ? true
            : false
        }
        path="/inspection"
        component={Inspection}
      />

      <PrivateRoute
        // permission={true}
        permission={
          user?.super_admin
            ? true
            : permissions_obj["Admin"]
            ? true
            : permissions_obj["Workflow"]
            ? true
            : false
        }
        role={
          packageDetails?.package?.title !== "Enterprise" &&
          packageDetails?.package?.title !== "Free"
            ? true
            : company?.role === "admin"
            ? true
            : company?.role === "management"
            ? true
            : false
        }
        sidebar={true}
        path="/workflow"
        component={workflow}
      />

      <PrivateRoute
        sidebar={true}
        permission={true}
        role={
          packageDetails?.package?.title !== "Enterprise" &&
          packageDetails?.package?.title !== "Free"
            ? true
            : company?.role === "admin"
            ? true
            : company?.role === "inspector"
            ? true
            : false
        }
        path="/action"
        component={Action}
      />
      <PrivateRoute
        sidebar={true}
        permission={true}
        role={true}
        path="/account"
        component={Account}
      />

      <PrivateRoute
        sidebar={true}
        // permission={true}
        permission={
          user?.super_admin
            ? true
            : permissions_obj["Admin"]
            ? true
            : permissions_obj["Data Access"]
            ? true
            : false
        }
        role={
          packageDetails?.package?.title !== "Enterprise" &&
          packageDetails?.package?.title !== "Free"
            ? true
            : company?.role === "admin"
            ? true
            : company?.role === "management"
            ? true
            : false
        }
        sidebarToggle={false}
        exact
        path="/analytics"
        component={Analytics}
      />

      <PrivateRoute
        sidebar={true}
        // permission={true}
        permission={
          user?.super_admin
            ? true
            : permissions_obj["Admin"]
            ? true
            : permissions_obj["Data Access"]
            ? true
            : false
        }
        role={
          packageDetails?.package?.title !== "Enterprise" &&
          packageDetails?.package?.title !== "Free"
            ? true
            : company?.role === "admin"
            ? true
            : company?.role === "management"
            ? true
            : false
        }
        sidebarToggle={false}
        exact
        path="/analytics/performance"
        component={Performance}
        // component={(props) => (
        //   <Performance
        //     func={(e) => this.props.hideNav(e)}
        //     showside={(e) => this.props.showNav(e)}
        //   />
        // )}
      />

      <PrivateRoute
        sidebar={true}
        // permission={true}
        permission={
          user?.super_admin
            ? true
            : permissions_obj["Admin"]
            ? true
            : permissions_obj["Executive Dashboard "]
            ? true
            : false
        }
        role={
          packageDetails?.package?.title !== "Enterprise" &&
          packageDetails?.package?.title !== "Free"
            ? true
            : company?.role === "admin"
            ? true
            : company?.role === "management"
            ? true
            : false
        }
        sidebarToggle={false}
        exact
        path="/executive-dashboard"
        component={ExecutiveNav}
        // component={(props) => (
        //   <Performance
        //     func={(e) => this.props.hideNav(e)}
        //     showside={(e) => this.props.showNav(e)}
        //   />
        // )}
      />

      <PrivateRoute
        sidebar={true}
        // permission={true}
        permission={
          user?.super_admin
            ? true
            : permissions_obj["Admin"]
            ? true
            : permissions_obj["Data Access"]
            ? true
            : false
        }
        role={
          packageDetails?.package?.title !== "Enterprise" &&
          packageDetails?.package?.title !== "Free"
            ? true
            : company?.role === "admin"
            ? true
            : company?.role === "management"
            ? true
            : false
        }
        sidebarToggle={false}
        exact
        path="/analytics/action"
        component={(props) => (
          <ActionAnalytics
            func={(e) => this.props.hideNav(e)}
            showside={(e) => this.props.showNav(e)}
          />
        )}
      />

      <PrivateRoute
        sidebar={true}
        permission={
          user?.super_admin
            ? true
            : permissions_obj["Admin"]
            ? true
            : permissions_obj["Template Creation"]
            ? true
            : false
        }
        role={
          packageDetails?.package?.title !== "Enterprise" &&
          packageDetails?.package?.title !== "Free"
            ? true
            : company?.role === "admin"
            ? true
            : company?.role === "inspector"
            ? true
            : false
        }
        path="/template-editor/create"
        component={(props) => (
          <TemplaleEdit
            // showside={(e) => this.props.showNav(e)}
            // permission={true}
            permissions={
              user?.super_admin
                ? true
                : permissions_obj["Admin"]
                ? true
                : permissions_obj["Template Creation"]
                ? true
                : false
              // false
            }
          />
        )}
      />

      <PrivateRoute
        sidebar={true}
        permission={true}
        role={true}
        exact
        path="/task/:id"
        component={(props) => (
          <TaskCreate func={(e) => this.props.hideNav(e)} />
        )}
      />

      <PrivateRoute
        sidebar={true}
        // permission={true}
        permission={
          user?.super_admin
            ? true
            : permissions_obj["Admin"]
            ? true
            : permissions_obj["Schedule Management"]
            ? true
            : false
        }
        role={
          packageDetails?.package?.title !== "Enterprise" &&
          packageDetails?.package?.title !== "Free"
            ? true
            : company?.role === "admin"
            ? true
            : company?.role === "inspector"
            ? true
            : false
        }
        path="/schedule-create"
        component={scheduleCreate}
      />

      <PrivateRoute
        sidebar={true}
        // permission={true}
        permission={
          user?.super_admin
            ? true
            : permissions_obj["Admin"]
            ? true
            : permissions_obj["Schedule Management"]
            ? true
            : false
        }
        role={
          packageDetails?.package?.title !== "Enterprise" &&
          packageDetails?.package?.title !== "Free"
            ? true
            : company?.role === "admin"
            ? true
            : company?.role === "inspector"
            ? true
            : false
        }
        path="/schedule-edit/:id"
        component={scheduleCreate}
      />
      <PrivateRoute
        sidebar={true}
        path="/inspection-edit/:id/:isReview"
        permission={true}
        role={
          packageDetails?.package?.title !== "Enterprise" &&
          packageDetails?.package?.title !== "Free"
            ? true
            : company?.role === "admin"
            ? true
            : company?.role === "inspector"
            ? true
            : false
        }
        component={InspectionEdit}
      />
      <PrivateRoute
        permission={true}
        sidebar={true}
        role={true}
        path="/inspection-print/:id/:isCompleted/:pdf_url"
        component={InspectionPrint}
      />
      <PrivateRoute
        permission={true}
        sidebar={true}
        role={true}
        path="/notifications/"
        component={Notification}
      />
      <PrivateRoute
        permission={true}
        sidebar={true}
        role={
          packageDetails?.package?.title !== "Enterprise" &&
          packageDetails?.package?.title !== "Free"
            ? true
            : company?.role === "admin"
            ? true
            : company?.role === "management"
            ? true
            : false
        }
        path="/pricing/"
        component={Pricing}
      />

      <PrivateRoute
        sidebar={true}
        exact
        // permission={true}
        permission={
          user?.super_admin
            ? true
            : permissions_obj["Admin"]
            ? true
            : permissions_obj["Billing Management"]
            ? true
            : false
        }
        role={true}
        path="/update_package"
        component={AddPackagePlan}
      />
      <PrivateRoute
        sidebar={true}
        exact
        // permission={true}
        permission={
          user?.super_admin
            ? true
            : permissions_obj["Admin"]
            ? true
            : permissions_obj["Billing Management"]
            ? true
            : false
        }
        role={true}
        path="/update_package/:package_type/:is_monthly/:currency"
        component={PackageBuy}
      />

      <PrivateRoute
        sidebar={true}
        exact
        // permission={true}
        permission={
          user?.super_admin
            ? true
            : permissions_obj["Admin"]
            ? true
            : permissions_obj["Billing Management"]
            ? true
            : false
        }
        role={true}
        path="/lisence_add"
        component={LicenseAdd}
      />

      <PrivateRoute
        sidebar={true}
        exact
        // permission={true}
        permission={
          user?.super_admin
            ? true
            : permissions_obj["Admin"]
            ? true
            : permissions_obj["Billing Management"]
            ? true
            : false
        }
        role={true}
        path="/lisence_renew"
        component={LicenseRenew}
      />
    </Switch>
  );
}
